import React from "react";
import { FormattedMessage } from "react-intl";

const Copyright = () => (
  <ul className="copyright">
    <li>
      &copy; {new Date().getFullYear()} Ewwo Consulting.{" "}
      <FormattedMessage id="copyright" />
    </li>
    <li>
      <FormattedMessage id="design" />
      <a href="http://html5up.net">HTML5 UP</a>
    </li>
  </ul>
);

export default Copyright;



// WEBPACK FOOTER //
// ./src/components/Copyright.js